import apiClient from "../../../utilities/apiClient";
import LocalStorage from "../../../utilities/localStorage";

export const get_lot_numbers = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_id = user.vendor_id;
  return apiClient.get(
    `${apiClient.Urls.lot_accept_numbers}?vendor_id=${vendor_id}`,
    payload,
    true
  );
};

export const asns = (payload) => {
  return apiClient.post(`${apiClient.Urls.asns}`, payload, true, "file");
};

export const get_asns = (payload) => {
  var user = LocalStorage.getItem("tata_login_user");
  const vendor_id = user.vendor_id;
  return apiClient.get(
    `${apiClient.Urls.asns_list}?vendor_id=${vendor_id}`,
    payload,
    true
  );
};

export const get_packaging_types = (payload) => {
  // var user = LocalStorage.getItem("tata_login_user");
  // const vendor_id = user.vendor_id;
  return apiClient.get(`${apiClient.Urls.packaging_type_info}`, payload, true);
};

export const view_UserAsnDetails = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.view_user_asn_details}/${payload}`,
    "",
    true
  );
};

export const get_lot_items = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.get_lot_items}/?lot_id=${payload}`,
    payload,
    true
  );
};